import type { GetLoanLimitQuery } from '../API';
import type { GraphQLResult } from '@aws-amplify/api-graphql';

import { GRAPHQL_AUTH_MODE } from '@aws-amplify/api-graphql';
import { API } from 'aws-amplify';
import { useQuery } from 'react-query';

import * as queries from '$/graphql/queries';

const useMaximumFinancing = ({
  majorId,
  graduationId,
  fieldId,
}: {
  majorId: number;
  graduationId: number;
  fieldId: number;
}) => {
  const { data: loanLimit, isLoading } = useQuery(
    ['maximumLoan', majorId, graduationId, fieldId],
    async () =>
      (await API.graphql({
        query: queries.getLoanLimit,
        variables: { majorId, graduationId, fieldId },
        authMode: GRAPHQL_AUTH_MODE.API_KEY,
      })) as GraphQLResult<GetLoanLimitQuery>,
    {
      enabled: !!((majorId || fieldId) && graduationId),
      refetchOnWindowFocus: false,
    }
  );

  return { loanLimit, isLoading };
};

export default useMaximumFinancing;
